// bfm_viewer.js

// Manage the molecular viewer.
import { viewerMaker, resizeCanvas } from './MainCanvas';

// Paste and Drag and Drop
import { initDropHandling } from './paste_drag';

import { EventBroker } from './eventbroker';
import { CanvasWrapperId } from './utils';

/**
 * Let the 3D view hold keyboard focus.
 *
 * Canvas shortcuts are gated on canvasHasFocus(). The wrapper was not focusable and
 * nothing blurred on canvas click, so once focus landed on a control -- a Selector tab
 * header, the compound filter -- there was no click anywhere that returned it, and the
 * shortcuts stayed dead for the rest of the session (BP2-888).
 *
 * tabIndex -1 makes it focusable programmatically and by click without joining the tab
 * order. No preventDefault, so 3dmol's own mousedown handling is untouched.
 */
function makeCanvasFocusable(eltId) {
    const elt = document.getElementById(eltId);
    if (!elt) {
        console.warn(`makeCanvasFocusable: no element #${eltId}; canvas shortcuts may get stuck`);
        return;
    }
    elt.tabIndex = -1;
    elt.style.outline = 'none'; // no focus ring around the 3D view
    // Focus can land here, so give assistive tech something to announce instead of an
    // unnamed div. No role: the wrapper is not a landmark and role=application would
    // change how screen readers interpret every key inside it.
    elt.setAttribute('aria-label', '3D molecular viewer');
    elt.addEventListener('mousedown', () => elt.focus({ preventScroll: true }));
}

export function makeBFMViewer(viewerOptions={}) {
    const canvasParentId = CanvasWrapperId;
    const options = { parentEltId: canvasParentId, ...viewerOptions };
    viewerMaker(options);
    makeCanvasFocusable(canvasParentId);
    // Initialize the Tour first so that it gets keyboard events before
    // the rest of bmaps (EventBroker publishing is set up in info_display (not InfoDisplay.jsx)).
    // This lets the tour ignore keyboard evts based on various elt visibility.
    // Tour wouldn't be able to ignore Escape if Escape had already closed the
    // pane it was checking the visibility of!
    resizeViewer(canvasParentId); // first time sizing
    $(window).resize(() => { resizeViewer(canvasParentId); });
    EventBroker.subscribe('resize', () => { resizeViewer(canvasParentId); });
    initDropHandling();
    console.log('BFM viewer initialized.');
}

function resizeViewer(viewer) {
    // Use all the viewport except for the title bar.
    const bfv = $(`#${viewer}`);
    const tb = $('#topbar');
    const tlbHeight = tb.outerHeight(true); // title bar plus margin
    const winHeight = $(window).innerHeight(); // viewport height
    const width = $(window).innerWidth(); // viewport width
    const height = winHeight - tlbHeight;
    // Update the bfm viewer container.
    const leftSidePanelWidth = $('#leftsidepanel').innerWidth() || 0;
    const rightSidePanelWidth = $('#rightsidepanel').innerWidth() || 0;
    bfv.width(width - leftSidePanelWidth - rightSidePanelWidth);
    bfv.height(height);
    // We could resize the canvas ourselves, the but the underlying visualization packages
    // need to know about it too, to update the gl.viewport and such.
    resizeCanvas(width, height);
}
